var exports = {
  "n": "skeletonContainer__QhlZQT",
  "k": "templateHeader__p7i_tK",
};

module.exports = exports;
